import { useCallback } from "react";

export default function StoreModeActions({
  storeMode,
  updatingStoreMode,
  adminRole,
  setUpdatingStoreMode,
  adminFetch,
  apiBaseUrl,
  readApiJson,
  setStoreMode,
  setAdminError,
  setAdminToast,
  texts
}) {
  const updateStoreMode = useCallback(async (mode) => {
    if (mode === storeMode || updatingStoreMode || adminRole !== "admin") {
      return;
    }

    setUpdatingStoreMode(true);
    try {
      const response = await adminFetch(`${apiBaseUrl}/admin/store-mode`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ mode })
      });

      const data = await readApiJson(response);
      if (!response.ok) {
        throw new Error(data.message || "Store mode update failed");
      }

      setStoreMode(data.mode === "b2b" ? "b2b" : "b2c");
      setAdminError("");
      setAdminToast(`${texts.modeSavedToast}: ${(data.mode || "b2c").toUpperCase()}`);
    } catch (err) {
      if (err.message !== "Session expired") {
        setAdminError(err.message || "Store mode update failed");
      }
    } finally {
      setUpdatingStoreMode(false);
    }
  }, [
    adminFetch,
    adminRole,
    apiBaseUrl,
    readApiJson,
    setAdminError,
    setAdminToast,
    setStoreMode,
    setUpdatingStoreMode,
    storeMode,
    texts.modeSavedToast,
    updatingStoreMode
  ]);

  return { updateStoreMode };
}